import { z } from 'zod'
import { isValidRut } from '@/shared/utils/rutValidator'

// --- User (API response) ---
export interface User {
  id: number
  name: string
  last_name: string
  rut: string
  email: string
  role: string
  id_branch_office: number
  id_company: number
}

// --- Form schema for create ---
export const userCreateFormSchema = z.object({
  name: z.string().min(1, 'Nombre es requerido'),
  last_name: z.string().min(1, 'Apellido es requerido'),
  rut: z
    .string()
    .min(1, 'RUT es requerido')
    .refine((val) => isValidRut(val), { message: 'RUT inválido' }),
  email: z.string().email('Email inválido'),
  password: z
    .string()
    .min(6, 'Contraseña debe tener al menos 6 caracteres'),
  id_branch_office: z.number({ required_error: 'Sucursal es requerida' }),
})

export type UserCreateFormData = z.infer<typeof userCreateFormSchema>

// --- Form schema for edit (password optional) ---
export const userEditFormSchema = z.object({
  name: z.string().min(1, 'Nombre es requerido'),
  last_name: z.string().min(1, 'Apellido es requerido'),
  rut: z
    .string()
    .min(1, 'RUT es requerido')
    .refine((val) => isValidRut(val), { message: 'RUT inválido' }),
  email: z.string().email('Email inválido'),
  password: z.string().optional().default(''),
  id_branch_office: z.number({ required_error: 'Sucursal es requerida' }),
})

export type UserEditFormData = z.infer<typeof userEditFormSchema>

// --- Filters for list ---
export interface UserFilters {
  page: number
  limit: number
  param?: string
  value?: string
  exact_match?: boolean
}
